"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _olx = _interopRequireDefault(require("./olx"));
var _grupoZap = _interopRequireDefault(require("./grupoZap"));
var _brands = require("../../../../themes/brands");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var getButtonTheme = function getButtonTheme(brand, type) {
  var themes = {};
  themes[_brands.OLX] = _olx["default"];
  themes[_brands.GRUPO_ZAP] = _grupoZap["default"];
  return themes[brand][type];
};
var _default = exports["default"] = getButtonTheme;